

window.locale = {

    translate(string) {
        return string;
    }

}